/**
 * Round-off input sanitization.
 * Default mode auto-prefixes "0." when typing digits without a decimal (e.g. "12" → "0.12").
 * Simple mode keeps the value as typed (only validates numeric input).
 */
export function sanitizeRoundOffInput(
  value,
  { allowNegative = false, simple = false } = {},
) {
  if (value === "" || value === null || value === undefined) return "";

  const str = String(value);

  if (simple) {
    const pattern = allowNegative ? /^-?\d*\.?\d*$/ : /^\d*\.?\d*$/;
    return pattern.test(str) ? str : null;
  }

  const negative = allowNegative && str.startsWith("-");
  const raw = negative ? str.slice(1) : str;

  if (raw === "") return negative ? "-" : "";

  const pattern = allowNegative ? /^-?\d*\.?\d*$/ : /^\d*\.?\d*$/;
  if (!pattern.test(str)) return null;

  if (!raw.includes(".") && /^\d+$/.test(raw)) {
    return negative ? `-0.${raw}` : `0.${raw}`;
  }

  return negative ? `-${raw}` : raw;
}

export function handleRoundOffInputChange(event, onValueChange, options = {}) {
  const sanitized = sanitizeRoundOffInput(event.target.value, options);
  if (sanitized !== null) {
    onValueChange(sanitized);
  }
}

export const roundOffInputFieldProps = {
  type: "text",
  inputMode: "decimal",
  placeholder: "0.00",
};
